import { createSelector } from '@reduxjs/toolkit';
import { selectFloor } from 'shared/selectors/jsonQuery';

export const selectFloorFilter = createSelector(selectFloor, ({ gte = null, lte = null }) => ({
  label: 'Этаж',
  value: { min: gte, max: lte },
  min: 1,
  max: 200,
}));
